module.exports = __webpack_public_path__ + "img/pet-breeds.14b69bad.png";